/**
 * Created by tofael on 11/4/17.
 */

import React from 'react';
import TextField from 'material-ui/TextField';
import {green500, white} from 'material-ui/styles/colors';
import {typography} from 'material-ui/styles';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from 'material-ui/Checkbox';
import UplodIcon from 'material-ui/svg-icons/action/backup';
import Divider from 'material-ui/Divider';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';

const style = {
  form: {
    marginLeft: 10,
    marginRight: 10
  },
  box: {
    backgroundColor: '#fff',
    transition: 'none',
    border: 'none',
    borderRadius: '5px',
    position: 'relative',
    marginBottom: '24px',
    boxShadow: '0 5px 5px 0 rgba(0,0,0,.25)',
    overflow: 'hidden'
  },
  button: {
    marginTop: 12,
    marginBottom: 12,
    marginRight: 12,
    float: 'right'
  },
  checkbox: {
    marginTop: 20,
    marginRight: 5,
    marginBottom: 0
  },
  header: {
    fontSize: 18,
    marginTop: 20,
    fontWeight: typography.fontWeightLight
  }
};

const DoctorForm = (props) =>{
  const { handleChange, onCheck, available_specialities, handleSubmit, isLoading, onPhotoSelect, onSelectSpeciality } = props;
  const {
    id, name, phone, email, photo, permanent_address_street, permanent_address_area, permanent_address_postcode,
    current_address_street, current_address_area, current_address_postcode, credentials, speciality, current_engagement, current_engagement_institute,
    doc_reg_no, passing_year, passed_from, provider, operator
  } = props.state;
  const { physical, remote} = props.state.doctor_fee;
  const { physical: physical_within_week, remote: remote_within_week } = props.state.doctor_fee_within_week;
  const { physical: physical_within_month, remote: remote_within_month } = props.state.doctor_fee_within_month;
  
  return (
    <div style={style.box}>
    <form style={style.form} onSubmit={handleSubmit}>

      <div style={style.header}>Personal Information</div>
      <TextField
        hintText="Full name"
        floatingLabelText="Name"
        underlineShow={false}
        required={true}
        value={name}
        onChange={handleChange.bind(null, 'name')}
      />
      <Divider />

      <div className="row">
        <div className="col-md-6">
          <TextField
            hintText="Phone number"
            floatingLabelText="Phone"
            underlineShow={false}
            disabled={id!== undefined}
            required={true}
            value={phone}
            onChange={handleChange.bind(null, 'phone')}
          />
          <Divider />
        </div>
        <div className="col-md-6">
          <TextField
            hintText="Email"
            floatingLabelText="Email"
            underlineShow={false}
            required={true}
            disabled={id!==undefined}
            value={email}
            onChange={handleChange.bind(null, 'email')}
          />
          <Divider />
        </div>
      </div>
      <br/>

      <div className="row">
        <div className="col-md-6">
          <RaisedButton
            containerElement="label"
            icon={<UplodIcon/>} // material-ui-icons
            label="Select Photo">
            <input
              onChange={e => onPhotoSelect(e)}
              style={{ display: 'none' }}
              type="file"
            />
          </RaisedButton>
          {
            photo &&
            photo.name
          }
        </div>
      </div>

      <div className="row">
        <div className="col-xs-6 col-lg-6 col-md-6">
          <div style={style.header}>Current Address</div>
          <TextField
            hintText="Address Line 1"
            floatingLabelText="Address Line 1"
            underlineShow={false}
            value={current_address_street}
            onChange={handleChange.bind(null, 'current_address_street')}
          />
          <Divider />
          <TextField
            hintText="Address Line 2"
            floatingLabelText="Address Line 2"
            underlineShow={false}
            value={current_address_area}
            onChange={handleChange.bind(null, 'current_address_area')}
          />
          <Divider />
          <TextField
            hintText="Post Code"
            floatingLabelText="Post Code"
            underlineShow={false}
            type="number"
            value={current_address_postcode}
            onChange={handleChange.bind(null, 'current_address_postcode')}
          />
          <Divider />
        </div>
        <div className="col-xs-6 col-lg-6 col-md-6">
          <div style={style.header}>Permanent Address</div>
          <TextField
            hintText="Address Line 1"
            floatingLabelText="Address Line 1"
            underlineShow={false}
            value={permanent_address_street}
            onChange={handleChange.bind(null, 'permanent_address_street')}
          />
          <Divider />
          <TextField
            hintText="Address Line 2"
            floatingLabelText="Address Line 2"
            underlineShow={false}
            value={permanent_address_area}
            onChange={handleChange.bind(null, 'permanent_address_area')}
          />
          <Divider />
          <TextField
            hintText="Post Code"
            floatingLabelText="Post Code"
            underlineShow={false}
            type="number"
            value={permanent_address_postcode}
            onChange={handleChange.bind(null, 'permanent_address_postcode')}
          />
          <Divider />
        </div>
      </div>
      <div style={style.header}>Speciality</div>
      <SelectField
          value={speciality}
          floatingLabelText="Select speciality"
          onChange={onSelectSpeciality}>
          { available_specialities
          .map(d => 
            <MenuItem 
            primaryText={d.speciality}
            key={d.id}
            value={d.speciality}/>
          ) }
      </SelectField>

      <div style={style.header}>Academic Information</div>
      <TextField
        hintText="Display credential for doctor"
        floatingLabelText="Credentials"
        underlineShow={false}
        value={credentials}
        onChange={handleChange.bind(null, 'credentials')}/>
      <Divider />
      <div className="row">
        <div className="col-md-6">
          <TextField
            hintText="Year of passing mbbs"
            floatingLabelText="Year of passing mbbs"
            underlineShow={false}
            type="number"
            value={passing_year}
            onChange={handleChange.bind(null, 'passing_year')}
          />
          <Divider />
        </div>
        <div className="col-md-6">
          <TextField
            floatingLabelText="Institute"
            underlineShow={false}
            value={passed_from}
            onChange={handleChange.bind(null, 'passed_from')}
          />
          <Divider />
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <TextField
            hintText="Current course"
            floatingLabelText="Current course"
            underlineShow={false}
            value={current_engagement}
            onChange={handleChange.bind(null, 'current_engagement')}
          />
          <Divider />
        </div>
        <div className="col-md-6">
          <TextField
            hintText="Current course institute"
            floatingLabelText="Current course institute"
            underlineShow={false}
            value={current_engagement_institute}
            onChange={handleChange.bind(null, 'current_engagement_institute')}
          />
          <Divider />
        </div>
      </div>


      <div className="row">
        <div className="col-md-6">
          <TextField
            hintText="BMDC registration number"
            floatingLabelText="BMDC registration number"
            underlineShow={false}
            value={doc_reg_no}
            onChange={handleChange.bind(null, 'doc_reg_no')}
          />
          <Divider />
        </div>
      </div> 
      
          { 
          provider && 
          <div className="row">
           <div className="col-md-6">
            <div style={style.header}>Physical Fee</div>
            <TextField
              hintText="Physical Regular"
              floatingLabelText="Physical Regular"
              underlineShow={false}
              type="number"
              value={physical}
              onChange={handleChange.bind(null, 'physical')}
            />
            <Divider />
            <TextField
              hintText="Physical Within A Week"
              floatingLabelText="Physical Within A Week"
              underlineShow={false}
              type="number"
              value={physical_within_week}
              onChange={handleChange.bind(null, 'physical_within_week')}
            />
            <Divider />
            <TextField
              hintText="Physical Within A Month"
              floatingLabelText="Physical Within A Month"
              underlineShow={false}
              type="number"
              value={physical_within_month}
              onChange={handleChange.bind(null, 'physical_within_month')}
            />
            <Divider />
           </div>
            <div className="col-xs-6 col-lg-6 col-md-6">
            <div style={style.header}>Remote Fee</div>
            <TextField
              hintText="Remote Regular"
              floatingLabelText="Remote Regular"
              underlineShow={false}
              type="number"
              value={remote}
              onChange={handleChange.bind(null, 'remote')}
            />
            <Divider />
            <TextField
              hintText="Remote Within a Week"
              floatingLabelText="Remote Within a Week"
              underlineShow={false}
              type="number"
              value={remote_within_week}
              onChange={handleChange.bind(null, 'remote_within_week')}
            />
            <Divider />
            <TextField
              hintText="Remote Within A Month"
              floatingLabelText="Remote Within A Month"
              underlineShow={false}
              type="number"
              value={remote_within_month}
              onChange={handleChange.bind(null, 'remote_within_month')}
            />
            <Divider />
           </div>
          </div>
          }
        
        <div className="row">
        <div className="col-md-6">
          <div style={style.header}>
            Select Role
          </div>
          <Checkbox
            label="Visiting Doctor"
            style={style.checkbox}
            checked={provider}
            onCheck={onCheck.bind(null, 'provider')}
          />
          <Checkbox
            label="Call Center Doctor"
            style={style.checkbox}
            checked={operator}
            onCheck={onCheck.bind(null, 'operator')}
          />
        </div>
        </div>

      <div style={style.button}>
        <RaisedButton
          label="Submit"
          type="submit"
          backgroundColor={green500}
          labelColor={white}
          disabled={isLoading}
        />
      </div>
    </form>
    </div>
  )
}

export default DoctorForm;


// WEBPACK FOOTER //
// ./src/screens/shared/doctor-form.js